import ModalParticipantAtmp from "./modal/modalParticipantAtmp.jsx";

import AtmpResume from "./atmpMainListComponent/atmpResume.jsx";
import AtmpTable from "./atmpMainListComponent/atmpTable.jsx";
import AtmpToolBar from "./atmpMainListComponent/atmpToolbar.jsx";
import { useState } from "react";

function DataAtmp() {
  const [yearState, setYearState] = useState("");
  const handleChangeToolbar = (filter, value) => {
    if (filter === "year") setYearState(value);
  };
  return (
    <>
      <div>
        <ul className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="#/">ATMP</a>
          </li>
          <li className="breadcrumb-item active">Data</li>
        </ul>
        <h1 className="page-header">
          Annual Training Master Plan <small></small>
        </h1>

        <hr className="mb-4" />
        <AtmpToolBar year={yearState} onChange={handleChangeToolbar} />
        <AtmpResume year={yearState} />
        <AtmpTable year={yearState} atmpData={(e) => setYearState(e.year)} />
      </div>
    </>
  );
}

export default DataAtmp;
